export default {
  nome: {
    value: '',
    maxlength: '70',
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/campaign/whatsapp/components/search/search-form.js